/* eslint-disable max-lines-per-function */
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Command, CommandGroup, CommandItem } from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { cn } from '@/lib/utils';
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

export function CalendarSelect() {
  const { kalender, selectedKalenderIds, setSelectedKalenderIds } =
    useCalendarContext();
  const [open, setOpen] = useState(false);

  function handleSelect(kalenderId: string) {
    if (selectedKalenderIds.includes(kalenderId)) {
      const selectedKalender = selectedKalenderIds.filter(
        (id) => id !== kalenderId,
      );
      setSelectedKalenderIds(selectedKalender);
    } else {
      setSelectedKalenderIds([...selectedKalenderIds, kalenderId]);
    }
  }

  return (
    <>
      {!kalender ? (
        ''
      ) : (
        <Popover onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className={cn(open ? 'bg-neutrals-N300' : '')}>
              <FontAwesomeIcon icon={faCalendarStar} />
            </Button>
          </PopoverTrigger>
          <PopoverContent
            className="bg-white w-[16rem] items-stretch p-1"
            align="end"
            side="bottom"
            sideOffset={2}>
            <Command className="flex gap-2 w-full">
              <CommandGroup className="flex flex-col gap-2 justify-betweens w-full">
                {kalender.map((kalender) => (
                  <CommandItem
                    className="transition-colors text-sm font-normal"
                    key={kalender.id}
                    value={kalender.name}
                    onSelect={() => handleSelect(kalender.id)}>
                    <div className="flex justify-between items-center w-full">
                      <span>{kalender.name}</span>
                      <Checkbox
                        checked={selectedKalenderIds.includes(kalender.id)}
                      />
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            </Command>
          </PopoverContent>
        </Popover>
      )}
    </>
  );
}
